import React from "react";
import {
  IndicatorText,
  TimerBox,
  TimerSection,
  TimerText,
  TimerWrapper,
} from "./elements";

function CustomTimer() {
  return (
    <TimerWrapper>
      <div className="whole-wrapper">
        <TimerSection>
          <div className="individual-wrapper">
            <TimerBox>
              <TimerText>0</TimerText>
            </TimerBox>
            <TimerBox>
              <TimerText>0</TimerText>
            </TimerBox>
          </div>
          <IndicatorText>Days</IndicatorText>
          <p className="colon-tag"> :</p>
        </TimerSection>
        <TimerSection>
          <div className="individual-wrapper">
            <TimerBox>
              <TimerText>0</TimerText>
            </TimerBox>
            <TimerBox>
              <TimerText>0</TimerText>
            </TimerBox>
          </div>
          <IndicatorText>Hours</IndicatorText>
          <p className="colon-tag"> :</p>
        </TimerSection>

        <TimerSection>
          <div className="individual-wrapper">
            <TimerBox>
              <TimerText>0</TimerText>
            </TimerBox>
            <TimerBox>
              <TimerText>0</TimerText>
            </TimerBox>
          </div>
          <IndicatorText>Minutes</IndicatorText>
          <p className="colon-tag"> :</p>
        </TimerSection>

        <TimerSection>
          <div className="individual-wrapper">
            <TimerBox>
              <TimerText>0</TimerText>
            </TimerBox>
            <TimerBox>
              <TimerText>0</TimerText>
            </TimerBox>
          </div>
          <IndicatorText>Seconds</IndicatorText>
        </TimerSection>
      </div>
    </TimerWrapper>
  );
}

export default CustomTimer;
